import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ResetConfirm from './ResetConfirm'
import { actions } from '../../store'

const mapStateToProps = state => ({
  organization: state.organization,
  user: state.user,
  auth: state.auth
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getOrganizationByName: actions.organization.getOrganizationByName,
  authorize: actions.auth.authorize
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetConfirm)



// WEBPACK FOOTER //
// ./src/views/ResetConfirm/index.js